import React, { Component } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "antd";
import {
  PagesHeading,
  FixedWidth,
} from "../../../../CommonComponents/commonStyles";
import { InfoField } from "./Component/ViewEditSchedules/style";
import { GrantSuccessMessage, SectionMediumDividerPrint } from "./style";
import SoftAlert from "../../../../CommonComponents/Info/SoftAlert/SoftAlert.js";
import {
  ContentProvider,
  ContentMessage,
  Types,
} from "../../../../CommonComponents/ContentMessages";
import InfoInline from "./Component/ViewEditSchedules/Components/InfoInline";
import Step1SummaryPrint from "./Component/ViewEditSchedules/Components/Step1SummaryPrint";
import Step2SummaryPrint from "./Component/ViewEditSchedules/Components/Step2SummaryPrint";
import PermissionToPublish from "./Component/ViewEditSchedules/Components/PermissionToPublish";
import ViewRecurSchedule from "./Component/ViewEditSchedules/Components/ViewRecurSchedule";
import PageAccountSummary from "../../../../CommonComponents/PageSummary/PageAccountSummary/PageAccountSummary";

export default class RecommendGrantConfirmationPagePrint extends Component {
  render() {
    return (
      <ContentProvider
        types={[Types.PAGE_NOTICES, Types.GET_CONFIRMATION_MESSAGE]}
        pages={["Recommend a Grant- Confirmation"]}
      >
        <FixedWidth>
          <PagesHeading style={{ marginTop: "10px" }}>
            Grant Recommendation Confirmation
          </PagesHeading>
          <InfoField wordBreakOnly>
            <GrantSuccessMessage style={{ paddingTop: "20px" }}>
              <ContentMessage
                type={[Types.GET_CONFIRMATION_MESSAGE]}
                page="Recommend a Grant- Confirmation"
                property="field_success_message"
                html={true}
                defaultMessage="<p>Congratulations! You have successfully submitted a grant recommendation.</p>"
              />
            </GrantSuccessMessage>
            <SoftAlert
              mainbody={
                <ContentMessage
                  page="Recommend a Grant- Confirmation"
                  type={Types.PAGE_NOTICES}
                  property="field_notice_content"
                  html={true}
                  defaultMessage="Your grant recommendation will be reviewed as soon as possible. If additional information is needed, someone will
                                        reach out to you. The status of the grant recommendation can be found by logging in to your account and clicking on
                                        Grants and then Grant Activity."
                />
              }
            />
          </InfoField>
          <SectionMediumDividerPrint smallMarginTop />
          <Row type="flex" justify="space-between" align="center">
            <Col span={24} lg={12}>
              <PageAccountSummary
                key="accountName"
                label={this.props.accountName}
                value={this.props.accountNumber}
                dataName="accountName"
              />
              <InfoInline
                title="Transaction ID"
                value={
                  this.props.grantId
                    ? this.props.grantId
                    : this.props.scheduleId
                }
              />
              <InfoInline title="Entered Date" value={this.props.enteredDate} />
            </Col>
            <Col></Col>
          </Row>
          <SectionMediumDividerPrint smallMarginTop />
          <Step1SummaryPrint
            charityInfo={this.props.charityInfo}
            purposeRecognition={this.props.purposeRecognition}
            codeValueMappingData={this.props.codeValueMappingData}
          />
          <SectionMediumDividerPrint smallMarginBottom smallMarginTop />
          <PermissionToPublish publish={this.props.publishName} />
          <SectionMediumDividerPrint smallMarginTop />
          <Step2SummaryPrint {...this.props.amountAllocation} />
          {this.props.scheduleType === "recurring" && (
            <>
              <SectionMediumDividerPrint smallMarginTop />
              <ViewRecurSchedule
                title="Recurring Grant Schedule"
                scheduleData={this.props.scheduleData}
              />
              <SectionMediumDividerPrint smallMarginTop />
            </>
          )}
        </FixedWidth>
      </ContentProvider>
    );
  }
}

RecommendGrantConfirmationPagePrint.propTypes = {
  accountName: PropTypes.string,
  accountNumber: PropTypes.string,
  amountAllocation: PropTypes.shape({
    allShares: PropTypes.bool,
    allSharesAllPools: PropTypes.bool,
    allocationType: PropTypes.string,
    allocations: PropTypes.array,
    amountString: PropTypes.string,
    endDate: PropTypes.string,
    frequency: PropTypes.string,
    paymentType: PropTypes.string,
    recurring: PropTypes.bool,
    startDate: PropTypes.string,
    title: PropTypes.string,
  }),
  charityInfo: PropTypes.shape({
    charityAddress: PropTypes.shape({
      addressLine1: PropTypes.string,
      addressLine2: PropTypes.string,
      addressLine3: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      zipCode: PropTypes.string,
    }),
    charityEin: PropTypes.string,
    charityName: PropTypes.string,
    title: PropTypes.string,
  }),
  codeValueMappingData: PropTypes.object,
  enteredDate: PropTypes.string,
  grantId: PropTypes.string,
  publishName: PropTypes.bool,
  purposeRecognition: PropTypes.shape({
    accountName: PropTypes.string,
    additionalComments: PropTypes.string,
    advisors: PropTypes.array,
    eventName: PropTypes.string,
    grantRecognition: PropTypes.string,
    inHonorOfName: PropTypes.string,
    inMemoryOfName: PropTypes.string,
    includeAdvisorInfo: PropTypes.bool,
    missionaryLocation: PropTypes.string,
    missionaryName: PropTypes.string,
    notifyName: PropTypes.any,
    projectName: PropTypes.string,
    purposeName: PropTypes.string,
    thirdParty: PropTypes.string,
    title: PropTypes.string,
  }),
  scheduleData: PropTypes.shape({
    Table: PropTypes.oneOfType([PropTypes.elementType, PropTypes.func]),
    amount: PropTypes.string,
    frequency: PropTypes.string,
    grantName: PropTypes.string,
    noOfPayments: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    startDate: PropTypes.string,
  }),
  scheduleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  scheduleType: PropTypes.string,
};
